import React from 'react';
import {
  mappers,
  NoResults,
  Pagination,
  Stats,
  WhiteInstantSearchBuilder,
} from '@white-nl/instantsearch-components';
import { HitComponent, LoadingComponent } from '@white-nl/instantsearch-components/dist/types/components';
import SortBy from '../components/refinements/SortBy';
import RefinementListPanel from '../components/refinements/RefinementListPanel';
import RefinementList from '../components/refinements/RefinementList';
import RangeSlider from '../components/refinements/RangeSlider';
import CurrentRefinements from '../components/catalog/refinements/CurrentRefinements';
import initCatalog from '../../../components/Catalog';
import HierarchicalMenu from '../components/catalog/refinements/HierarchicalMenu/HierarchicalMenu';
import { Hit, Loading } from '../components/catalog/results';
import FlatMenu from '../components/catalog/refinements/FlatMenu/FlatMenu';
import { ChevronDown } from '../components/ui/icons/sharp/regular';

const settings = document.getElementById('product-category')?.dataset || null;
const whiteInstantSearchCatalog = new WhiteInstantSearchBuilder();
if (settings && settings.sessionUrl) {
  fetch(settings.sessionUrl, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  }).then((res) => res.json())
    .then((sessionInfo) => {
      const apiUrl = Craft.getSiteUrl('api/react/catalog', { type: settings.currentCategoryType === 'productSelection' ? 'productSelection' : 'catalog' });

      fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((res) => res.json())
        .then((data) => {
          const {
            translates,
            colorMap,
            wishlistIds,
            categories,
            categoriesSorting,
            categoriesIds,
          } = data;

          const {
            catalog,
            pagination,
          } = translates;

          const indexName = settings.indexName || '';

          const salesCard = document.getElementById('sales-card')?.outerHTML;
          const usps = document.getElementById('catalog-usp-strip')?.outerHTML;
          const storeCard = document.getElementById('store-card')?.outerHTML;

          let cardsPerPage = 16;
          if (salesCard) {
            cardsPerPage -= 1;
          }
          if (storeCard) {
            cardsPerPage -= 1;
          }

          let pathAttribute = '';
          if (settings.currentCategoryType === 'brands') {
            pathAttribute = 'productBrands';
          } else if (settings.currentCategoryType === 'productCategories') {
            pathAttribute = 'categories.lvl1';
          }

          const { refinement, refinementCategory, categorySortingOverwrite } = settings;
          let refinementCategorySortingOverwrite = null;
          if (categorySortingOverwrite) {
            refinementCategorySortingOverwrite = JSON.parse(categorySortingOverwrite);
          }

          let categorySorting = null;
          if (refinementCategorySortingOverwrite) {
            categorySorting = refinementCategorySortingOverwrite.reduce(
              // @ts-ignore
              (acc, { id, lft }) => ({ ...acc, [id]: lft }),
              {},
            );
          }

          const stripSorting = categorySorting ?? categoriesSorting;

          const searchQuery = window.location.search ? window.location.search.substring(1) : '';
          let currentRefinement = refinement;
          let categoryRefinement = refinementCategory;
          if (settings.currentCategoryType === 'searchPage') {
            currentRefinement = searchQuery;
          } else if (settings.currentCategoryType === 'brands') {
            currentRefinement = refinementCategory;
            categoryRefinement = '';
          }
          let menuAttributes = ['categories.lvl1'];
          const mapItems = mappers.transformers.mapValues(categories);
          let transformedItemList = mapItems;
          if (settings.currentCategoryType === 'productCategories') {
            menuAttributes = ['categories.lvl1', 'categories.lvl2'];
          } else if (settings.currentCategoryType === 'productSelection') {
            menuAttributes = ['productCategories'];
            transformedItemList = (items) => {
              const filteredItems = items ? items.filter((item) => categoryRefinement === '' || categoryRefinement?.includes(`productCategories=${item.value}`)) : [];
              return mapItems(filteredItems);
            };
          }

          whiteInstantSearchCatalog
            .withSearchkit(
              indexName,
              settings.publicUrl || '',
              settings.jwt || '',
              settings.refreshUrl || '',
            )
            .withWhiteInstantSearchRouting({
              baseUrl: settings.baseUrl,
              pathAttribute,
              addTrailingSlashesToUrls: Craft.trailingSlashes,
              writeDelay: 0,
            })
            .addAdditionalData({
              sessionInfo,
              translates,
              colorMap,
              salesCard,
              storeCard,
              usps,
              wishlistIds,
              refinement: currentRefinement,
              categoriesIds,
            })
            .addSortByComponent(
              [
                {
                  settings: {
                    items: [
                      {
                        label: Craft.t(catalog, 'Latest'),
                        value: indexName,
                      },
                      {
                        label: Craft.t(catalog, 'Name (z-a)'),
                        value: `${indexName}products_by_title_desc`,
                      },
                      {
                        label: Craft.t(catalog, 'Name (a-z)'),
                        value: `${indexName}products_by_title_asc`,
                      },
                      {
                        label: Craft.t(catalog, 'Highest price'),
                        value: `${indexName}products_by_price_desc`,
                      },
                      {
                        label: Craft.t(catalog, 'Lowest price'),
                        value: `${indexName}products_by_price_asc`,
                      },
                    ],

                  },
                  component: SortBy,
                },
              ],
            )
            .addCurrentRefinementsComponent([
              {
                settings: {
                  excludedAttributes: ['categories.lvl1', 'productBrands'],
                  classNames: {
                    rootList: 'list-none ml-0 my-0 flex gap-x-3 gap-y-4',
                    listItem: 'flex gap-x-2 lg:gap-x-2.5 gap-y-4',
                    label: 'w-max text-base leading-normal text-near-black py-1',
                    list: 'list-none ml-0 my-0 inline-flex gap-x-2 lg:gap-x-2.5 gap-y-4',
                    link: 'inline-flex items-center gap-x-2.5 text-base leading-normal font-semibold no-underline rounded-full bg-light-shade-blue-1 text-near-black py-1 pl-3 pr-8 transition-all duration-300 whitespace-nowrap cursor-pointer relative hover:bg-light-grey-1 after:right-3 after:absolute after:w-3 after:h-5 after:content-(--icon-xmark)',
                  },
                  clearRefinementsSettings: {
                    classNames: {
                      button: 'inline-flex items-center py-1 pr-6 gap-x-2.5 text-base leading-normal font-semibold text-near-black transition-all duration-300 whitespace-nowrap cursor-pointer relative hover:text-orange after:right-0 after:absolute after:w-3.25 after:h-5 after:content-(--icon-trash-can)',
                    },
                  },
                  translations: {
                    clearAll: Craft.t(catalog, 'Clear all'),
                    onSale: Craft.t(catalog, 'On Sale'),
                    newProduct: Craft.t(catalog, 'New'),
                    insoleRemovableYes: Craft.t(catalog, 'Insole Removable: Yes'),
                    insoleRemovableNo: Craft.t(catalog, 'Insole Removable: No'),
                  },
                },
                component: CurrentRefinements,
              },
            ], '.current-refinements')
            .addStatsComponent(
              [
                {
                  settings: {
                    translations: {
                      resultsFound: Craft.t(catalog, 'results found'),
                      resultFound: Craft.t(catalog, 'result found'),
                    },
                  },
                  component: Stats,
                },
              ],
              '.hits-count',
            )
            .addStatsComponent(
              [
                {
                  settings: {
                    translations: {
                      resultsFound: '',
                      resultFound: '',
                    },
                  },
                  component: Stats,
                },
              ],
              '.filters-count',
            )
            .addHitComponent(
              [
                {
                  settings: {
                    noResults: {
                      translations: {
                        noResults: Craft.t(catalog, 'Sorry, we can\'t find any products!'),
                        refinements: Craft.t(catalog, 'Try to choose another category or filter.'),
                        query: Craft.t(catalog, 'Please try another query.'),
                      },
                    },
                  },
                  component: Hit as HitComponent,
                  loadingComponent: Loading as LoadingComponent,
                  noResultsComponent: NoResults,
                },
              ],
              '#white-instant-search-hits',
            );
          whiteInstantSearchCatalog
            .addHierarchicalMenu([
              {
                settings: {
                  attributes: menuAttributes,
                  hardRefresh: true,
                  separator: '/',
                  sortBy: (a, b) => {
                    const positionA = stripSorting[a.escapedValue] || -1;
                    const positionB = stripSorting[b.escapedValue] || -1;

                    if (positionA > positionB) {
                      return 1;
                    }
                    if (positionA < positionB) {
                      return -1;
                    }

                    return 0;
                  },
                  transformItems: transformedItemList,
                  classNames: {
                    list: 'list-none m-0 p-0 swiper-wrapper',
                    item: 'swiper-slide p-0 m-0 mr-3.75! w-auto!',
                    root: 'category-strip-swiper swiper h-10! px-3! -mx-3!',
                    link: 'h-10 inline-block no-underline text-base/10 text-center px-4 border border-dark/10 hover:bg-dark hover:text-white transition-all bg-light text-gray-500 group-[.active]/link:bg-dark group-[.active]/link:text-white',
                  },
                  limit: 999,
                },
                component: settings.currentCategoryType === 'productCategories' ? HierarchicalMenu : FlatMenu,
              },
            ], '#white-instant-category-refinements')
            .addHierarchicalMenu([
              {
                settings: {
                  attributes: menuAttributes,
                  hardRefresh: true,
                  separator: '/',
                  sortBy: (a, b) => {
                    const positionA = stripSorting[a.escapedValue] || -1;
                    const positionB = stripSorting[b.escapedValue] || -1;

                    if (positionA > positionB) {
                      return 1;
                    }
                    if (positionA < positionB) {
                      return -1;
                    }

                    return 0;
                  },
                  transformItems: transformedItemList,
                  classNames: {
                    list: 'list-none m-0 p-0',
                    item: 'p-0 m-0',
                    link: 'text-dark text-base leading-6 no-underline transition-all hover:pl-2 transition-all group-[.active]/link:text-accent',
                  },
                  limit: 999,
                },
                component: settings.currentCategoryType === 'productCategories' ? HierarchicalMenu : FlatMenu,
              },
            ], '#white-instant-search-category-refinements');
          if (settings.currentCategoryType === 'brands') {
            whiteInstantSearchCatalog
              .addHierarchicalMenu([
                {
                  settings: {
                    attributes: ['productBrands'],
                    limit: 999,
                  },
                  component: HierarchicalMenu,
                },
              ], '#white-instant-brands-refinements');
          }
          whiteInstantSearchCatalog
            .addSearchingComponent(
              [
                {
                  settings: {},
                  component: () => null,
                },
              ],
            )
            .addRefinementList(
              [{
                settings: {
                  attribute: 'sizes',
                  sortBy: ['name:asc'],
                  limit: 999,
                  classNames: {
                    label: 'cursor-pointer px-1 relative no-checkbox sizes hover:bg-gray-200 transition-all text-center py-1 bg-gray-100 flex justify-center items-center group-[.ais-RefinementList-item--selected]/size:bg-dark group-[.ais-RefinementList-item--selected]/size:hover:bg-dark group-[.ais-RefinementList-item--selected]/size:text-light',
                    checkbox: 'absolute opacity-0 size-full cursor-pointer',
                    count: 'hidden',
                    item: 'group/size swiper-slide flex items-center gap-2 min-w-14! w-auto! h-9 mr-2 p-0',
                    list: 'swiper-wrapper list-none m-0 p-0',
                    root: 'size-strip-swiper swiper h-9! px-3! -mx-3!',
                  },
                  searchable: false,
                  showMore: false,
                  panelSettings: {
                    collapsiblePanelSettings: {
                      classNames: {
                        root: 'hidden',
                        header: 'hidden',
                      },
                      defaultExpanded: true,
                      canCollapse: true,
                    },
                    header: '',
                    hideIfEmpty: true,
                  },
                },
                component: RefinementList,
              },
              ],
              '#white-instant-size-refinements',
            )
            .addRefinementList(
              [{
                settings: {
                  attribute: 'sizes',
                  sortBy: ['name:asc'],
                  limit: 999,
                  classNames: {
                    label: 'cursor-pointer px-1 relative no-checkbox sizes w-full hover:bg-gray-200 transition-all text-center py-1 bg-gray-100 flex justify-center items-center group-[.ais-RefinementList-item--selected]/size:bg-dark group-[.ais-RefinementList-item--selected]/size:hover:bg-dark group-[.ais-RefinementList-item--selected]/size:text-light',
                    checkbox: 'absolute opacity-0 size-full cursor-pointer',
                    count: 'hidden',
                    item: 'group/size flex items-center gap-2 min-w-14! w-auto! h-9 p-0 shrink-0',
                    list: 'list-none m-0 p-0 flex gap-2 flex-wrap pb-8',
                    root: '',
                  },
                  searchable: false,
                  showMore: false,
                  panelSettings: {
                    collapsiblePanelSettings: {
                      classNames: {
                        root: 'form-wrap',
                        header: '',
                      },
                      defaultExpanded: true,
                      canCollapse: true,
                    },
                    header: Craft.t(catalog, 'Size'),
                    hideIfEmpty: true,
                  },
                },
                component: RefinementListPanel,
              },
              ],
            )
            .addRefinementList(
              [{
                settings: {
                  attribute: 'colors',
                  classNames: {
                    label: 'cursor-pointer relative color-checkbox relative w-full text-center text-sm h-full py-0 pl-1 pr-2.5 rounded-full bg-light flex justify-between items-center border border-dark/10 transition-all group-[.ais-RefinementList-item--selected]/size:border-dark group-[.ais-RefinementList-item--selected]/size:bg-gray-100 group-hover/size:border-dark group-hover/size:bg-gray-100',
                    checkbox: 'absolute opacity-0 size-full cursor-pointer',
                    count: 'items-center justify-center text-sm leading-normal text-gray-500',
                    item: 'group/size flex items-center gap-2 w-30! h-7 p-0 shrink-0',
                    list: 'list-none m-0 p-0 flex gap-2 flex-wrap pb-8',
                    root: '',
                  },
                  searchable: false,
                  showMore: false,
                  panelSettings: {
                    collapsiblePanelSettings: {
                      classNames: {
                        root: 'form-wrap',
                        header: '',
                      },
                      defaultExpanded: true,
                      canCollapse: true,
                    },
                    header: Craft.t(catalog, 'Color'),
                    hideIfEmpty: true,
                  },
                },
                component: RefinementListPanel,
              },
              ],
            );
          if (settings.currentCategoryType !== 'brands') {
            whiteInstantSearchCatalog
              .addRefinementList([
                {
                  settings: {
                    attribute: 'brands',
                    sortBy: ['name:asc'],
                    limit: 6,
                    showMoreLimit: 999,
                    classNames: {
                      label: 'group/label relative block cursor-pointer h-8 pl-10 text-base text-black leading-8',
                      checkbox: 'absolute opacity-0 cursor-pointer',
                      count: 'min-w-6 h-6 items-center justify-center py-0.5 px-2 ms-2 bg-gray-100 text-sm leading-normal text-gray-500',
                      item: 'flex items-center gap-2 p-0 m-0',
                      list: 'list-none my-0 ml-0 flex flex-col gap-3.5',
                      showMore: 'btn btn-link btn-dark btn-xxs mt-4.5 no-icon-animation',
                      disabledShowMore: 'hidden!',
                    },
                    searchable: false,
                    showMore: true,
                    translations: {
                      showMoreButtonText({ isShowingMore }) {
                        return (
                          <>
                            {isShowingMore ? Craft.t(catalog, 'Show less') : Craft.t(catalog, 'Show more')}
                            <ChevronDown iconClass={`icon${isShowingMore ? ' rotate-180 translate-y-0.5' : ''}`} />
                          </> as unknown as string
                        );
                      },
                      submitButtonTitle: Craft.t(catalog, 'Submit the search query'),
                      resetButtonTitle: Craft.t(catalog, 'Clear the search query'),
                    },
                    panelSettings: {
                      collapsiblePanelSettings: {
                        classNames: {
                          root: 'form-wrap',
                          header: 'filter-title h4',
                        },
                        defaultExpanded: true,
                        canCollapse: true,
                      },
                      header: Craft.t(catalog, 'Brand'),
                      hideIfEmpty: true,
                    },
                  },
                  component: RefinementListPanel,
                },
              ]);
          }

          whiteInstantSearchCatalog
            .addRangeSlider(
              [
                {
                  settings: {
                    attribute: 'salePrice',
                    showThumbValues: true,
                    format: {
                      from: Craft.formatCurrency,
                      to: Craft.formatCurrency,
                    },
                    panelSettings: {
                      header: Craft.t(catalog, 'Price'),
                      collapsiblePanelSettings: {
                        classNames: {
                          root: 'form-wrap',
                          header: 'filter-title h4',
                        },
                        defaultExpanded: true,
                        canCollapse: true,
                      },
                    },
                  },
                  component: RangeSlider,
                },
              ],
            )
            .addRefinementList(
              [{
                settings: {
                  attribute: 'highlights',
                  sortBy: ['name:desc'],
                  limit: 999,
                  classNames: {
                    label: 'group/label relative block cursor-pointer h-8 pl-10 text-base text-black leading-8',
                    checkbox: 'absolute opacity-0',
                    count: 'min-w-6 h-6 items-center justify-center py-0.5 px-2 ms-2 bg-gray-100 text-sm leading-normal text-gray-500',
                    item: 'flex items-center gap-2',
                    list: 'list-none my-0 ml-0 flex flex-col gap-3.5',
                    root: 'slide',
                  },
                  searchable: false,
                  showMore: false,
                  transformItems: (items) => items.map((item) => ({
                    ...item,
                    label: (item.label === 'sale') ? Craft.t(catalog, 'On Sale') : Craft.t(catalog, 'New'),
                  })),
                  translations: {
                    showMoreButtonText({ isShowingMore }) {
                      return isShowingMore ? Craft.t(catalog, 'Show less') : Craft.t(catalog, 'Show more');
                    },
                    submitButtonTitle: Craft.t(catalog, 'Submit the search query'),
                    resetButtonTitle: Craft.t(catalog, 'Clear the search query'),
                  },
                  panelSettings: {
                    collapsiblePanelSettings: {
                      classNames: {
                        root: 'form-wrap',
                        header: 'filter-title h4',
                      },
                      defaultExpanded: true,
                      canCollapse: true,
                    },
                    header: Craft.t(catalog, 'Highlights'),
                    hideIfEmpty: true,
                  },
                },
                component: RefinementListPanel,
              },
              ],
            )
            .addRefinementList([
              {
                settings: {
                  attribute: 'materials',
                  sortBy: ['name:asc'],
                  limit: 999,
                  classNames: {
                    label: 'group/label relative block cursor-pointer h-8 pl-10 text-base text-black leading-8',
                    checkbox: 'absolute opacity-0',
                    count: 'min-w-6 h-6 items-center justify-center py-0.5 px-2 ms-2 bg-gray-100 text-sm leading-normal text-gray-500',
                    item: 'flex items-center gap-2 p-0 m-0',
                    list: 'list-none my-0 ml-0 flex flex-col gap-3.5 pb-8',
                    root: 'slide',
                  },
                  searchable: false,
                  showMore: false,
                  translations: {
                    showMoreButtonText({ isShowingMore }) {
                      return isShowingMore ? Craft.t(catalog, 'Show less') : Craft.t(catalog, 'Show more');
                    },
                    submitButtonTitle: Craft.t(catalog, 'Submit the search query'),
                    resetButtonTitle: Craft.t(catalog, 'Clear the search query'),
                  },
                  panelSettings: {
                    collapsiblePanelSettings: {
                      classNames: {
                        root: 'form-wrap',
                        header: 'filter-title h4',
                      },
                      defaultExpanded: false,
                      canCollapse: true,
                    },
                    header: Craft.t(catalog, 'Material'),
                    hideIfEmpty: true,
                  },
                },
                component: RefinementListPanel,
              },
            ])
            .addRefinementList([
              {
                settings: {
                  attribute: 'discountPercentage',
                  sortBy: ['name:asc'],
                  limit: 999,
                  classNames: {
                    label: 'group/label relative block cursor-pointer h-8 pl-10 text-base text-black leading-8',
                    checkbox: 'absolute opacity-0',
                    count: 'min-w-6 h-6 items-center justify-center py-0.5 px-2 ms-2 bg-gray-100 text-sm leading-normal text-gray-500',
                    item: 'flex items-center gap-2 p-0 m-0',
                    list: 'list-none my-0 ml-0 flex flex-col gap-3.5 pb-8',
                    root: 'slide',
                  },
                  searchable: false,
                  showMore: false,
                  translations: {
                    showMoreButtonText({ isShowingMore }) {
                      return isShowingMore ? Craft.t(catalog, 'Show less') : Craft.t(catalog, 'Show more');
                    },
                    submitButtonTitle: Craft.t(catalog, 'Submit the search query'),
                    resetButtonTitle: Craft.t(catalog, 'Clear the search query'),
                  },
                  panelSettings: {
                    collapsiblePanelSettings: {
                      classNames: {
                        root: 'form-wrap',
                        header: 'filter-title h4',
                      },
                      defaultExpanded: false,
                      canCollapse: true,
                    },
                    header: Craft.t(catalog, 'Discount Percentage'),
                    hideIfEmpty: true,
                  },
                },
                component: RefinementListPanel,
              },
            ])
            .addRefinementList(
              [{
                settings: {
                  attribute: 'insoleRemovable',
                  sortBy: ['name:desc'],
                  limit: 999,
                  transformItems: (items) => items.map((item) => ({
                    ...item,
                    label: (item.label === '1' || item.label === 'true') ? Craft.t(catalog, 'Yes') : Craft.t(catalog, 'No'),
                  })),
                  classNames: {
                    label: 'group/label relative block cursor-pointer h-8 pl-10 text-base text-black leading-8',
                    checkbox: 'absolute opacity-0',
                    count: 'min-w-6 h-6 items-center justify-center py-0.5 px-2 ms-2 bg-gray-100 text-sm leading-normal text-gray-500',
                    item: 'flex items-center gap-2',
                    list: 'list-none my-0 ml-0 flex flex-col gap-3.5 pb-8',
                    root: 'slide',
                  },
                  searchable: false,
                  showMore: false,
                  translations: {
                    showMoreButtonText({ isShowingMore }) {
                      return isShowingMore ? Craft.t(catalog, 'Show less') : Craft.t(catalog, 'Show more');
                    },
                    submitButtonTitle: Craft.t(catalog, 'Submit the search query'),
                    resetButtonTitle: Craft.t(catalog, 'Clear the search query'),
                  },
                  panelSettings: {
                    collapsiblePanelSettings: {
                      classNames: {
                        root: 'form-wrap',
                        header: 'filter-title h4',
                      },
                      defaultExpanded: false,
                      canCollapse: true,
                    },
                    header: Craft.t(catalog, 'Is Insole Removable'),
                    hideIfEmpty: true,
                  },
                },
                component: RefinementListPanel,
              },
              ],
            )
            .addRefinementList([
              {
                settings: {
                  attribute: 'productWidth',
                  sortBy: ['name:asc'],
                  limit: 999,
                  classNames: {
                    label: 'group/label relative block cursor-pointer h-8 pl-10 text-base text-black leading-8',
                    checkbox: 'absolute opacity-0',
                    count: 'min-w-6 h-6 items-center justify-center py-0.5 px-2 ms-2 bg-gray-100 text-sm leading-normal text-gray-500',
                    item: 'flex items-center gap-2 p-0 m-0',
                    list: 'list-none my-0 ml-0 flex flex-col gap-3.5',
                    root: 'slide',
                  },
                  searchable: false,
                  showMore: false,
                  translations: {
                    showMoreButtonText({ isShowingMore }) {
                      return isShowingMore ? Craft.t(catalog, 'Show less') : Craft.t(catalog, 'Show more');
                    },
                    submitButtonTitle: Craft.t(catalog, 'Submit the search query'),
                    resetButtonTitle: Craft.t(catalog, 'Clear the search query'),
                  },
                  panelSettings: {
                    collapsiblePanelSettings: {
                      classNames: {
                        root: 'form-wrap',
                        header: 'filter-title h4',
                      },
                      defaultExpanded: false,
                      canCollapse: true,
                    },
                    header: Craft.t(catalog, 'Product Width'),
                    hideIfEmpty: true,
                  },
                },
                component: RefinementListPanel,
              },
            ])
            .setHitsPerPage(cardsPerPage)
            .addPaginationComponent([
              {
                settings: {
                  classNames: {
                    noRefinementRoot: 'hidden',
                    list: 'list-none py-6 px-0 mx-0 my-auto xl:w-273.75 max-w-full flex flex-wrap md:justify-between items-center gap-2 md:gap-4',
                    pageItem: 'group/item p-0 *:block *:w-8 *:h-8 *:md:w-10 *:md:h-10 *:text-gray-400 *:group-hover/item:bg-dark *:group-[.active]/item:text-light *:group-[.active]/item:bg-dark *:group-hover/item:text-light',
                    link: 'text-center justify-start text-base md:text-lg font-normal leading-8 md:leading-10 line-clamp-1 no-underline transtion-all',
                    previousPageItem: 'md:grow p-0 basis-auto *:text-base *:md:text-lg *:text-dark',
                    selectedItem: 'active',
                    disabledItem: '*:pointer-events-none *:text-gray-400',
                    nextPageItem: 'md:grow p-0 basis-auto text-right *:text-base *:md:text-lg *:text-dark',
                  },
                  translations: {
                    previousPageItemText: Craft.t(pagination, 'Previous'),
                    nextPageItemText: Craft.t(pagination, 'Next'),
                  },
                  showFirst: false,
                  showLast: false,
                },
                component: Pagination,
              }])
            .setScrolling({
              includeAttributes: ['page'],
            });
          if (refinement) {
            whiteInstantSearchCatalog.whereQuery(refinement);
          }
          if (categoryRefinement) {
            whiteInstantSearchCatalog.whereQuery(categoryRefinement);
          }
          whiteInstantSearchCatalog
            .afterFirstRender(() => initCatalog())
            .build()
            .show();
        });
    });
}
